import type { PropsWithChildren, ReactNode } from 'react';
import styles from './HelpContent.module.scss';

export function HelpContent(props: PropsWithChildren): ReactNode {
	return <div className={styles['helpContent']}>{props.children}</div>;
}

export function HelpContentHeading(props: PropsWithChildren): ReactNode {
	return <div className={styles['helpContentHeading']}>{props.children}</div>;
}
